import { GetStaticProps, GetStaticPropsContext } from 'next';

import { ErrorContentSection } from '~/features/errors/components/error-content-section';
import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';

function FreeTrialForLayoffsLandingPage({ page }: { page: Page }) {
  return (
    <>
      <PageHead page={page} />
      <PageLayout withoutVerticalPadding>
        <ErrorContentSection
          glyphName='hourglass-two'
          text='The free trial for recently laid off workers promotion has ended.'
          title='Promotion no longer available.'
        />
      </PageLayout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => {
  // Stop additional locale pages except the default locale from being built
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const page = await getPage(`/free-trial/layoffs`);

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      page,
    },
  };
};

export default FreeTrialForLayoffsLandingPage;
